import { connect } from "react-redux";
import * as browserActions from "./actions";
import * as usersActions from "../../services/users/actions";

function mapStateToProps(state) {
  return {
    browser: state.browser,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getInitStatus: () => {
      dispatch(browserActions.get_init_status());
    },

    initSystem: () => {
      dispatch(browserActions.init_system());
    },

    resetSystem: () => {
      dispatch(browserActions.reset_system());
    },
    getResetStatus: () => {
      dispatch(browserActions.get_reset_status());
    },

    setMaintenance: (mode) => {
      dispatch(browserActions.set_maintenance(mode));
    },

    restartRouter: () => {
      dispatch(browserActions.restart_router());
    },

    restartProjections: () => {
      dispatch(browserActions.restart_projections());
    },

    changeEventListPage: (page) => {
      dispatch(browserActions.change_event_list_page(page));
    },

    changeEventListFilter: (type, key, value) => {
      dispatch(browserActions.change_event_list_filter(key, value));
    },

    getEvents: (from, to) => {
      dispatch(browserActions.get_event_list(from, to));
    },

    //By key

    changeEventByKeyListPage: (page) => {
      dispatch(browserActions.change_event_by_key_list_page(page));
    },

    changeEventByKeyListFilter: (type, key, value) => {
      dispatch(browserActions.change_event_by_key_list_filter(key, value));
    },

    getEventsByKey: (key) => {
      dispatch(browserActions.get_event_list_by_key(key));
    },

    // For Credits part
    getAccountInfosByAccountIds: (accountIds, fetchSSN) => {
      dispatch(usersActions.get_account_infos_for_users(accountIds, fetchSSN));
    },
  };
}

export const browserConnector = connect(mapStateToProps, mapDispatchToProps);
